import styled from 'styled-components';

export const StyledCronFormat = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;

  width: 100%;
  height: 44px;
`;

export const StyledRow = styled.div`
  display: flex;
  flex-direction: row;

  width: 100%;
`;

export const StyledColumn = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: 8px;

  width: 100%;
`;
